/* global window */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as errorCodes from '../../../config/errorCodes';
import { send } from '../../../actions/request/send';
import FlexmodeTokenRequest from '../../../model/requests/FlexmodeTokenRequest';
import FlexmodeTokenInfoRequest from '../../../model/requests/FlexmodeTokenInfoRequest';
import { MARKET_PREPAID } from '../../../helpers/constants';

/**
 * The CreditCardWrapper wraps the payment iframe and initializes it with a
 * payment token. Once the token is received in the iframe, the payment
 * form is build. When the user submits the form, an updated token is send from
 * the iframe to the wrapper. The wrapper then sends this token to the MVC
 * to receive shortened payment data. This data is then passed to our payment container.
 *
 * @constructor
 */
class CreditCardWrapper extends PureComponent {

  constructor(...args) {
    super(...args);
    // Will be added to the iframe's src url in order to bust
    // the cache of the iframe window. See https://jira.db-n.com/browse/OT-1512
    this.compCreationTime = Date.now();
  }

  componentDidMount() {
    if (process.browser) {
      require.ensure([], (require) => {
        require('cross-source/src/event-system');
        require('cross-source/src/cross-source');
        require('cross-source/src/util');
        require('cross-source/src/plugins/autogrow');
        this.initComcator();
      }, 'cross-source');
    }
  }

  componentWillUnmount() {
    if (this.comcator) {
      // @todo: https://jira.db-n.com/browse/OT-1381
      if (this.iframe.contentWindow.comcator) {
        this.iframe.contentWindow.destruct();
      }
      this.comcator.close();
    }
  }

  initComcator() {
    const { onCreditCardDataAvailable, onError, host, dispatch, personalData } = this.props;
    // bound to 'this' so we can use it in destruct.
    this.comcator = new window.CrossSource(this.iframe.contentWindow);
    window.CrossSource.util.config({
      comcator: this.comcator,
      plugins: {
        autogrow: {
          receive: true,
          emit: false,
          hideScrollbar: false,
        },
      },
    });

    this.comcator.on('iframe-ready', async () => {
      let token;
      try {
        const flexmodeTokenRequest = new FlexmodeTokenRequest(MARKET_PREPAID, 'cc', { ...personalData, payment_type: 'cc' });
        flexmodeTokenRequest.setPreventDefaultErrorHandling(true); // = no alert
        const flexmodeTokenResp = await dispatch(send(flexmodeTokenRequest));
        token = flexmodeTokenResp.body.data.flexmodeToken;
      } catch (err) {
        onError(err.response);
        return;
      }

      if (!token) {
        onError(errorCodes.CREDIT_CARD_GENERATE_TOKEN_ERROR);
        return;
      }

      this.comcator.emit('init', { token, host });
    });

    this.comcator.on('token-received', async (token) => {
      try {
        const resp = await dispatch(send(new FlexmodeTokenInfoRequest(MARKET_PREPAID, token, {
          isBlocking: true,
          preventDefaultErrorHandling: true, // no alert
        })));
        onCreditCardDataAvailable(resp);
      } catch (err) {
        onError(err.response);
      }
    });
  }

  render() {
    return (
      <iframe
        ref={(c) => { this.iframe = c; }}
        src={`/creditcart.iframe.html?rand=${this.compCreationTime}`}
        width="100%"
        height="350"
      />
    );
  }
}

CreditCardWrapper.propTypes = {
  onCreditCardDataAvailable: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  host: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  personalData: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({ dispatch });


export default connect(null, mapDispatchToProps)(CreditCardWrapper);

